// UploadUserModal.js
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteConfirmModal = ({ isOpen, onClose, id, onDelete, deletConfirmationMsg, type }) => {

    return (
        <Modal show={isOpen} onHide={onClose} centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Delete {type}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex justify-content-center align-items-center'>
                    <p className="mt-2">{deletConfirmationMsg}</p>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end gap-2">
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => {
                    onDelete(id);
                    setTimeout(() => {
                        onClose()
                    }, 500);
                }}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmModal;
